import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../_metronic/_partials/controls";

export function TransfersLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.transfers.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
